import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { INSPECTION_SETTINGS_PERMISSION, INSPECTION_SETTINGS_PATH } from '&/features/settings/inspections/paths';
import { requireModule } from '&/lib/module-gate';

export const Route = createFileRoute('/_authenticated/settings_/inspections')({
  beforeLoad: ({ context }): void => {
    // Entitlement: a tenant without the module that owns this path (per the registry) gets the
    // standard not-found. Covers client-side navigation only; the page wraps itself in <ModuleGate>
    // for the hard-refresh case.
    requireModule(context.entitlement, INSPECTION_SETTINGS_PATH);
    // Permission gate (separate concern): a viewer without `inspection-templates:manage` (an Inspector or Account Manager)
    // goes back to Settings.
    if (context.permissions.isReady && !context.permissions.hasPermission(INSPECTION_SETTINGS_PERMISSION)) {
      throw redirect({ to: '/settings' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/inspections/pages/inspection-settings-page')),
  staticData: { titleKey: 'inspectionSettings' },
});
